import { render, staticRenderFns } from "./FormsUpdate.vue?vue&type=template&id=58e09da4&"
import script from "./FormsUpdate.vue?vue&type=script&lang=js&"
export * from "./FormsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports